import raAdminMessages from 'ra-language-english'

export default raAdminMessages
